module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"To register public user account","titleDesc":"Please complete the following (all fields with (*) are mandatory for completion):"},"zh_hk":{"title":"註冊的人士公眾帳戶","titleDesc":"請完成以下操作（所有帶有（*）的字段均為必填項）："},"zh_cn":{"title":"注册公眾人士帐户","titleDesc":"请完成以下操作（所有带有（*）的字段均为必填项）："}}')
  delete Component.options._Ctor
}
